import InvoicesAPI from "../../api/invoices";

export const invoice = {
    namespaced: true,
    state: {
        invoices: [],
    },
    actions: {
        INDEX: ({ commit }) => {
            InvoicesAPI.INDEX()
                .then((response) => {
                    commit("INVOICES", response.data);
                })
                .catch(() => {
                    commit("INVOICES", []);
                });
        },

        DOWNLOAD: ({}, invoice) =>
            InvoicesAPI.DOWNLOAD(invoice.year, invoice.month)
                .then((response) => {
                    const url = window.URL.createObjectURL(response.data);
                    const link = window.document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute(
                        "download",
                        `fatture_${invoice.year}-${invoice.month}.xlsx`
                    );
                    window.document.body.appendChild(link);
                    link.click();
                })
                .catch(console.log),
    },

    mutations: {
        INVOICES: (state, invoices) => (state.invoices = invoices),
    },
};
